import { getToken } from "./auth";
import { getColumn } from "./get-column";

export const getDetailsFromFormFields = (formFields) => {
  const fields = [];
  const defaultValues = {};
  // Removed 'dateFields' as it was redundant and the actual default date values
  // are already correctly placed into 'defaultValues'.

  for (const element of formFields) {
    if (fields[element.sequence] == undefined) {
      fields[element.sequence] = [element];
    } else {
      fields[element.sequence].push(element);
    }

    // Handle default values based on element.defaultValue
    if (
      element.tag === "input" &&
      (element.inputType === "date" || element.inputType === "datetime-local")
    ) {
      const currentDate = new Date();
      if (element.defaultValue === "now") {
        defaultValues[element.fieldName] = new Date(
          currentDate.getTime() - currentDate.getTimezoneOffset() * 60_000
        )
          .toISOString()
          .slice(0, element.inputType === "date" ? 10 : 16);
      } else if (
        typeof element.defaultValue === "object" &&
        Object.prototype.hasOwnProperty.call(element.defaultValue, "time")
      ) {
        currentDate.setHours(...element.defaultValue.time);
        defaultValues[element.fieldName] = new Date(
          currentDate.getTime() - currentDate.getTimezoneOffset() * 60_000
        )
          .toISOString()
          .slice(0, 16);
      } else {
        defaultValues[element.fieldName] = element.defaultValue; // Use explicit default value if provided
      }
      // The 'dateFields' variable is no longer needed here as its purpose was fulfilled
      // by directly setting the default value in 'defaultValues'.
    } else {
      defaultValues[element.fieldName] =
        typeof element.defaultValues == "undefined"
          ? null
          : element.defaultValues;
    }
  }
  // Return null for dateFields as it's no longer used or needed.
  // The important part is that 'defaultValues' contains the correct date strings.
  const returnValue = { fields, defaultValues, dateFields: null };
  return returnValue;
};

export const checkIfValuesExist = (data, keys) => {
  for (const element of keys) {
    if (!data[element]) return false;
  }
  return true;
};

export const fetchDropdowns = async (fields, data, setDropdownOptions) => {
  console.log(data);

  let dropdownOptions = {};
  for (const field of fields) {
    if (field.tag === "select") {
      if (!field.data?.dependsOnField || data[field.data?.dependsOnField]) {
        let filter = {};
        const options = await getDropdownOptions(field, data, filter);
        dropdownOptions = {
          ...dropdownOptions,
          [field.fieldName]: options,
        };
      }
    }
    if (field.tag == "combobox" && !field.data?.dependsOnField) {
      const options = await field.getOptions();
      dropdownOptions = {
        ...dropdownOptions,
        [field.fieldName]: options,
      };
    }
  }
  setDropdownOptions((prev) => ({
    ...prev,
    ...dropdownOptions,
  }));
};

export const getDropdownOptions = async (field, data, filter) => {
  if (typeof field.data?.filter === "function") {
    filter = { ...filter, ...field.data.filter(data) };
  } else {
    filter = { ...filter, ...field.data?.filter };
  }
  if (Array.isArray(field.data?.dependsOnField)) {
    field.data.dependsOnField.forEach((item) => {
      filter[item] = data[item];
    });
  } else {
    if (field.data?.dependsOnField)
      filter[field.data.dependsOnField] = data[field.data.dependsOnField];
  }

  if (
    field.isMulti &&
    data[field.fieldName] &&
    typeof data[field.fieldName] === "string"
  ) {
    try {
      data[field.fieldName] = JSON.parse(data[field.fieldName]);
    } catch (e) {
      console.error(
        "Failed to parse multi-select string:",
        data[field.fieldName],
        e
      );
      data[field.fieldName] = [];
    }
  }

  let options = [];
  if (field.getOptions && field.getOptionLabel && field.getOptionValue) {
    options = await field.getOptions(data);
    console.log(options);
    return options;
  }

  if (field.data?.tableName) {
    options = await getColumn(
      field.data.tableName,
      field.data.columnName,
      filter
    );
  } else if (field.data?.url) {
    const token = getToken();
    let url = "";
    if (typeof field.data?.url == "function") {
      url = field.data?.url(data);
    }
    url =
      field.data.type == "query"
        ? `${field.data.url}?${new URLSearchParams(filter)}`
        : field.data.url;
    options = await fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      ...(field.data.type == "query" ? [{ body: filter }] : []),
    });
    if (field.data?.processOptions) {
      if (typeof field.data?.processOptions == "function") {
        options = await field.data?.processOptions(options, data);
      }
    }
  }

  return options;
};

export function objectToQueryString(obj) {
  const parts = [];

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];
      let encodedValue;

      // Handle arrays and nested objects by stringifying and encoding them
      if (typeof value === "object" && value !== null) {
        encodedValue = encodeURIComponent(JSON.stringify(value)); // Stringify and encode complex types
      } else {
        encodedValue = encodeURIComponent(value); // Encode simple values
      }

      parts.push(`${encodeURIComponent(key)}=${encodedValue}`); // Encode key and value
    }
  }

  return parts.join("&"); // Join key-value pairs with '&'
}